import {API} from 'aws-amplify';

export const read = (guestId, eventId) =>
  API.get('eventmanagerPublicApi', `/public/event/${eventId}/guest/${guestId}`, {});

export const readQr = (eventId) =>
  API.get('eventmanagerPublicApi', `/public/event/${eventId}`, {});

export const accept = (guestId, eventId, companions) =>
  API.post(
    'eventmanagerPublicApi',
    `/public/event/${eventId}/guest/${guestId}`,
    {body: {accept: true, companions}},
  );

export const acceptQr = (guest, eventId, companions) =>
  API.post(
    'eventmanagerPublicApi',
    `/public/veranstaltung/qr/${eventId}`,
    {body: {guest, companions}},
  );

export const deny = (guestId, eventId) =>
  API.post('eventmanagerPublicApi', `/public/event/${eventId}/guest/${guestId}`, {body: {accept: false}});
